import { type FC } from 'react'
import { Button } from '../../components/Button/Button'
import { requestedSeatsAlertCopy } from './requestedSeatsAlertCopy'
import { type SeatTypeShortage } from './useRequestedSeatShortage'

export interface RequestedSeatsAlertProps {
  types: SeatTypeShortage[]
  onBuySeats: () => void
}

export const RequestedSeatsAlert: FC<RequestedSeatsAlertProps> = ({ types, onBuySeats }) => {
  const copy = requestedSeatsAlertCopy(types)

  return copy ? (
    <div className='d-flex align-items-center gap-3 zocks-bg-color-primary-light rounded-1 p-3 mb-4'>
      <i className='bi bi-info-square zocks-text-primary flex-shrink-0' aria-hidden='true' />
      <span className='paragraph-medium zocks-text-gray-900'>{copy}</span>
      <Button variant='primary' className='ms-auto flex-shrink-0' onClick={onBuySeats}>
        Buy seats
      </Button>
    </div>
  ) : null
}
